module.exports = __webpack_public_path__ + "static/media/logo-xd.2a07d618.png";